import { createSelector } from "reselect";

const list = (state) => state.designChapter.currentView.options.list;

const droppedId = (_, ownProps) => ownProps.droppedId;

export const getComponentProps = createSelector(
  [list, droppedId],
  (list, droppedId) => {
    if (droppedId) {
      return list.find((listItem) => listItem.id === droppedId);
    } else {
      return {};
    }
  }
);
